class FilterNew extends HTMLElement { 
  constructor() { 
    super()
    this.onKeydown()
    this.onChange()
  }
  connectedCallback() { 
    this.showActiveFilters()
  }
  onChange() {
    this.addEventListener('input', (e) => { 
      this.updateResults(e)
    })
  }
  updateStyles() { 
    const activeFilters = this.querySelector('.active-filters')
    if(activeFilters.children.length > 0) {
      console.log(activeFilters.offsetHeight)
      document.documentElement.style.setProperty('--scrollbar-padding', `${activeFilters.getBoundingClientRect().height + 50}px`);
    }
  }
  updateURL(searchParams) { 
    window.history.replaceState({}, '', `?${searchParams.toString()}`)  
  }
  onKeydown() {
    this.addEventListener('keydown', (e) => {
      const key = e.key
      if (key === 'Enter' && e.target.tagName === 'LABEL') {
        const inputEvent = new Event('input', {
          bubbles: true,
          cancelable: true,
        })
        const checkbox = e.target.parentNode.querySelector('input')
        checkbox.checked = true
        checkbox.dispatchEvent(inputEvent)
      }
    })
  }
  showActiveFilters() { 
    const activeFilters = document.querySelector('.results__filters')
    if(activeFilters && activeFilters.children.length > 0) { 
      this.querySelector('.active-filters').classList.remove('hidden')
    }
  }
  updateResults(event) {   
    this.getActiveFilters()
    const searchParams = this.getSearchParams(event)

    let isFilter = false
    let typeChange = false
    if(event.target.name.includes('filter')) { 
      isFilter = true
      this.contentType = 'all'
    }
    if(event.target.name === 'content_type') { 
      typeChange = true
    }
    const filterUpdate = new CustomEvent('filterUpdate', { 
      bubbles: true,
      compose: true,
      detail: { 
        searchParams: searchParams,
        isFilter: isFilter, 
        typeChange: typeChange,
        contentType: this.contentType
      }
    })
    document.dispatchEvent(filterUpdate)
  }
  getActiveFilters() {
    this.filterValues = []
    this.filterValues.length = 0
    const filterItems = this.querySelectorAll('input[type="radio"], input[type="number"]')

    filterItems.forEach((item) => {
      const name = item.name
      const value = item.value
      const type = item.type
      if (
        (type === 'checkbox' && item.checked) ||
        (type === 'radio' && item.checked)
      ) {
        if (value) {
          this.filterValues.push(`${name}=${value}`)
        }
        if(name === 'content_type') { 
          this.contentType = item.value
        }
      } else if (type === 'number') {
        const numValue = value.trim() === '' ? '' : Number(value)
        this.filterValues.push(`${name}=${numValue}`)
      }
    })
  }
  getSearchParams(event) { 
    const searchParams = new URLSearchParams(window.location.search)
    this.filterValues.forEach(value => { 
      const param_name = value.split('=')[0]
      const param_value = value.split('=')[1]
      searchParams.set(param_name, param_value)
    })
    if(event.target.name.includes('filter')) { 
      if(searchParams.has('content_type')) { 
        searchParams.delete('content_type')
        // searchParams.set('content_type', 'all')
      }
      // update type to all on filter change to reset
      const types = this.querySelectorAll('input[name="content_type"]')
      types.forEach(type => { 
        type.checked = false
        if(type.value === 'all') { 
          type.checked = true
        }
      })
    }

    this.updateURL(searchParams)
    return searchParams
  }
}
customElements.define('filter-new', FilterNew)


class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this))
    })
    this.setMinAndMaxValues();
  }
  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];

    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);

    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);